import { Injectable, inject } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import type { UpsellsModalComponent } from './upsells-modal.component';

export interface UpsellsModalData {
  reservationUuid: string;
  initialMode?: 'overview' | 'pending-requests' | 'refunds';
}

@Injectable({
  providedIn: 'root',
})
export class UpsellsModalService {
  readonly #dialog = inject(MatDialog);
  #dialogRef: MatDialogRef<UpsellsModalComponent> | null = null;

  open(data: UpsellsModalData): void {
    import('./upsells-modal.component').then(({ UpsellsModalComponent }) => {
      this.#dialogRef = this.#dialog.open(UpsellsModalComponent, {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        panelClass: ['upsells-modal', '!m-0', '!rounded-none'],
        data,
        autoFocus: false,
        disableClose: true,
      });
    });
  }

  close(result?: unknown): void {
    if (this.#dialogRef) {
      this.#dialogRef.close(result);
      this.#dialogRef = null;
    }
  }

  isOpen(): boolean {
    return !!this.#dialogRef;
  }
}
